import React from "react";
import api from "../../api/organizations";

const initialData = {
  card: null,
};

export default function useOrganizationCard() {
  const [organizationCard, setOrganizationCard] = React.useState(initialData);

  function getOrganizationCard(id) {
    Promise.all([
      api.getOrganizationCard(id),
      api.getOrganizationWorldSkills(id),
      api.getOrganizationSpecialities(id),
    ]).then(([card, worldSkills, specialities]) => {
      setOrganizationCard({
        card: card.data,
        worldSkills: worldSkills.data,
        specialities: specialities.data,
        curator: card.data ? (card.data.info ? card.data.info.curator : null) : null
      });
    });
  }

  function resetCard() {
    setOrganizationCard(initialData)
  }

  return { getOrganizationCard, organizationCard, resetCard };
}
